module.exports = __webpack_public_path__ + "static/img/left.28b19b2b.png";